import React from 'react'

import { Badge, IconButton } from '@mui/material'

import { Warning } from '@mui/icons-material'

interface WarningIconButtonProps {
  content?: React.ReactNode
  shouldAppear?: boolean
  onClick: () => void
}

export const WarningIconButton: React.FC<WarningIconButtonProps> = ({
  shouldAppear,
  content,
  onClick
}) => {
  return (
    <IconButton
      onClick={onClick}
      style={{
        zIndex: 1,
        alignSelf: 'flex-start',
        padding: '15px',
        color: '#ff6e6e'
      }}
    >
      <Badge color='secondary' badgeContent={content} invisible={shouldAppear}>
        <Warning />
      </Badge>
    </IconButton>
  )
}
